<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>
  <div *ngIf="validRole" class="content">
    <data-table (detail)="navigateToEntrance($event)" (remove)="onDelete($event)" *ngIf="tableData" [columns]="columns"
                    [hideSearch]="true" [plainData]="tableData" title="Assigned Content"></data-table>

    <button (click)="addContent()" class="add-button" color="primary" mat-mini-fab><mat-icon class="mat-24">add</mat-icon></button>
  </div>
  <div *ngIf="!validRole" class="content">
    add first the role contentAuthor to this group and assign it with an organisation.
    see: manage roles
  </div>
</page-content>

